// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u0HM","top":"styles_top__3_bS8","left":"styles_left__1mFG1","description":"styles_description__39IZX"};